module.exports = __webpack_public_path__ + "static/media/postImageDefault.07b4140a.png";